"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _ImageRow = _interopRequireDefault(require("./ImageRow"));

var _default = function _default(_ref) {
  var imageGroups = _ref.imageGroups,
      rightArrow = _ref.rightArrow,
      leftArrow = _ref.leftArrow;
  return _react["default"].createElement(_semanticUiReact.Grid, {
    className: "ic-image-grid",
    stackable: true
  }, leftArrow, imageGroups.map(function (imageGroup) {
    return _react["default"].createElement(_ImageRow["default"], {
      key: JSON.stringify(imageGroup),
      imageGroup: imageGroup
    });
  }), rightArrow);
};

exports["default"] = _default;